import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({
  name: 'assets',
  standalone: false,
})
@Injectable({
  providedIn: 'root',
})
export class AssetsPipe implements PipeTransform {
  constructor() {}

  transform(imgName: string): string {
    return imgName.replace('assets/flyplus', 'assets/' + environment.theme);
  }
}
